export type AgentType =  "SUPPORT";

export const AGENT_API_PREFIX: Record<AgentType, string> = {
  SUPPORT: "helpdesk_agent"
};

export const AGENT_BASE_URLS: Record<AgentType, string | undefined> = {
  SUPPORT: `${import.meta.env.VITE_AGENT_AI_SUPPORT}`
};

